export default (): PaginationComponent => {
    return {
        async onNextPageClick() {
            if (this.pagination.currentPage < this.pagination.totalPages) {
                this.pagination.currentPage++;
                this.$dispatch("next-click", {currentPage: this.pagination.currentPage});
            }
        }
    };
};

import {AlpineComponent} from "alpinejs"
import {IPagination} from "../models/IPagination";

type PaginationComponent = AlpineComponent<{
    onNextPageClick: Function
}>
